<div class="period-picker-container" >
      <mat-select class="period-select" [(value)]="selected" (selectionChange)="onPeriodSelectionChange($event)" #select>
          <mat-option value="forever">All Time</mat-option>
          <mat-option value="year">Last 12 Months</mat-option>
          <mat-option value="semester">Last 6 Months</mat-option>
          <mat-option value="month">Last Month</mat-option>
          <mat-option value="week">Last Week</mat-option>
          <mat-option value="range">Custom Range</mat-option>
      </mat-select>
      <ng-container *ngIf="customRange">
        <div class="date-field">
          <input matInput [value]="picker_start_date" [matDatepicker]="start_date_picker" (dateChange)="updateDate('start_date', $event)">
          <mat-datepicker-toggle matIconSuffix [for]="start_date_picker"></mat-datepicker-toggle>
          <mat-datepicker #start_date_picker></mat-datepicker>
        </div>
        <div class="date-field">
          <input matInput [value]="picker_end_date" [matDatepicker]="end_date_picker" (dateChange)="updateDate('end_date', $event)">
          <mat-datepicker-toggle matIconSuffix [for]="end_date_picker"></mat-datepicker-toggle>
          <mat-datepicker #end_date_picker></mat-datepicker>
        </div>
      </ng-container>
</div>